import { AfterViewInit, Directive, ElementRef, inject, Input } from '@angular/core'

@Directive({
  selector: '[uid]',
  standalone: false,
})
export class TrackDirective implements AfterViewInit {
  private el = inject(ElementRef)
  @Input('uid')
  trackElement!: string

  trackEvents = ['focus', 'blur', 'click']

  // This directive 'eats' the attribute, so we need to set it on the element again for playwright purposes
  addAttribute(): void {
    this.el.nativeElement.setAttribute('uid', this.trackElement)
  }

  ngAfterViewInit(): void {
    this.addAttribute()
  }
}
